"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.006 3.4c-.281.005-.662.194-.749.821a65 65 0 0 1-.29 1.81h1.417a.7.7 0 0 1 0 1.4H7.728c-.222 1.303-.47 2.804-.684 4.318-.102.721-.37 1.298-.786 1.695-.418.4-.94.573-1.444.555-.965-.035-1.93-.794-1.93-1.953a.7.7 0 1 1 1.4 0c0 .288.246.542.58.554a.57.57 0 0 0 .427-.168c.135-.13.298-.389.367-.878.203-1.444.438-2.871.65-4.124H4.796a.7.7 0 1 1 0-1.4h1.75c.143-.831.258-1.518.325-2C7.049 2.734 7.996 2.015 8.984 2a1.96 1.96 0 0 1 1.34.49c.385.345.618.844.632 1.434a.7.7 0 1 1-1.4.033c-.005-.226-.086-.352-.167-.425a.56.56 0 0 0-.383-.132m-.129 5.452a.7.7 0 0 1 .99-.023l1.033.986 1.033-.986a.7.7 0 1 1 .967 1.013l-.986.941.986.941a.7.7 0 1 1-.967 1.013L10.9 11.75l-1.033.986a.7.7 0 0 1-.967-1.013l.986-.94-.986-.942a.7.7 0 0 1-.023-.99",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FormulaIcon16.js.map